import React from "react";
import logo from "../../assets/logo/radis.png";
import { ReactComponent as House } from "../../assets/navbar/House.svg";
import { ReactComponent as MagnifiyingGlass } from "../../assets/navbar/MagnifyingGlass.svg";
import { ReactComponent as GraphDown } from "../../assets/navbar/GraphDown.svg";
import { ReactComponent as FileImg } from "../../assets/navbar/File.svg";
import { ReactComponent as QuestionMark } from "../../assets/navbar/QuestionMark.svg";
import { ReactComponent as Cog } from "../../assets/navbar/Cog.svg";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { isDisabled } from "@testing-library/user-event/dist/utils";

const NavbarLeft = ({ currentPage }) => {
  const location = useLocation();

  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const current_period = useSelector((state) => (state.user.subscription_days_left ? state.user.subscription_days_left : null));
  // const current_period = 10;
  // const current_period = useSelector((state) => state.user);
  // console.log("toto")
  return (
    <>
      <div className="bg-white h-full w-[70px] border-r-[1px] border-[#BEC4C] fixed z-50 justify-between">
        <div className="relative top-0 w-[70px] h-[70px] border-b-[1px] border-[#BEC4C] flex items-center justify-center right-1">
          <img src={logo} alt="logo" className="h-[50px]" />
        </div>
        <div className="flex justify-center">
          <div className=" relative w-[70px] h-80">
            {currentPage == 1 ? (
              <>
                <div className="flex justify-center p-3 w-[70px] h-[74px]">
                  <div className="relative top-[10px] group">
                    <Link to="/Home" style={current_period > 0 ? null : { pointerEvents: "none" }}>
                      {/* <Link to="/Home"> */}
                      <House stroke="#169A6A" />
                    </Link>
                    <div className="bg-[#169A6A] h-15 p-3 absolute left-[-200px] bottom-[14px] rounded-full opacity-0 group-hover:left-[40px] group-hover:opacity-100 text-white">Accueil</div>
                  </div>
                  <div className="absolute rounded-3xl bg-[#169A6A] w-0.5 h-[45px] p-0 right-[68px]" />
                </div>
              </>
            ) : (
              <div className="flex justify-center p-3 w-[70px] h-[74px]">
                <div className="flex justify-center relative top-[10px] group">
                  <Link to="/Home" style={current_period > 0 ? null : { pointerEvents: "none" }}>
                    <House stroke="#7e84a3" />
                  </Link>
                  <div className="bg-[#169A6A] h-15 p-3 absolute left-[-200px] bottom-[14px] rounded-full opacity-0 group-hover:left-[40px] group-hover:opacity-100 text-white">Accueil</div>
                </div>
              </div>
            )}
            {currentPage == 2 ? (
              <>
                <div className="flex justify-center p-3 w-[70px] h-[74px]">
                  <div className="relative top-[10px]">
                    <Link to="/AnalysisHistory" style={current_period > 0 ? null : { pointerEvents: "none" }}>
                      <MagnifiyingGlass fill="#169A6A" />
                    </Link>
                    <div className="bg-[#169A6A] h-15 p-3 absolute left-[-200px] bottom-[14px] rounded-full opacity-0 group-hover:left-[40px] group-hover:opacity-100 text-white">Analyser</div>
                  </div>
                  <div className="absolute rounded-3xl bg-[#169A6A] w-0.5 h-[45px] p-0 right-[68px]" />
                </div>
              </>
            ) : (
              <div className="flex justify-center p-3 w-[70px] h-[74px]">
                <div className="flex justify-center relative top-[10px] group">
                  <Link to="/AnalysisHistory" style={current_period > 0 ? null : { pointerEvents: "none" }}>
                    <MagnifiyingGlass fill="#7e84a3" />
                  </Link>
                  <div className="bg-mainGreen h-15 p-3 absolute left-[-200px] bottom-[14px] rounded-full opacity-0 group-hover:left-[40px] group-hover:opacity-100 text-white">Analyser</div>
                </div>
              </div>
            )}
            {currentPage == 3 ? (
              <>
                <div className="flex justify-center p-3 w-[70px] h-[74px]">
                  <div className="relative top-[10px] group">
                    <Link to="/Reduce" style={current_period > 0 ? null : { pointerEvents: "none" }}>
                      <GraphDown fill="#169A6A" />
                    </Link>
                    <div className="bg-mainGreen h-15 p-3 absolute left-[-200px] bottom-[14px] rounded-full opacity-0 group-hover:left-[40px] group-hover:opacity-100 text-white">Réduire</div>
                  </div>
                  <div className="absolute rounded-3xl bg-mainGreen w-0.5 h-[45px] p-0 right-[68px]" />
                </div>
              </>
            ) : (
              <div className="flex justify-center p-3 w-[70px] h-[74px]">
                <div className="flex justify-center relative top-[10px] group">
                  <Link to="/Reduce" style={current_period > 0 ? null : { pointerEvents: "none" }}>
                    <GraphDown fill="#7e84a3" />
                  </Link>
                  <div className="bg-mainGreen h-15 p-3 absolute left-[-200px] bottom-[14px] rounded-full opacity-0 group-hover:left-[40px] group-hover:opacity-100 text-white">Réduire</div>
                </div>
              </div>
            )}
            {currentPage == 4 ? (
              <>
                <div className="flex justify-center p-3 w-[70px] h-[74px]">
                  <div className="relative top-[10px] group">
                    <Link to="/Com" style={current_period > 0 ? null : { pointerEvents: "none" }}>
                      <FileImg stroke="#169A6A" fill="#169A6A" />
                    </Link>
                    <div className="bg-mainGreen h-15 p-3 absolute left-[-200px] bottom-[14px] rounded-full opacity-0 group-hover:left-[40px] group-hover:opacity-100 text-white">Communiquer</div>
                  </div>
                  <div className="absolute rounded-3xl bg-mainGreen w-0.5 h-[45px] p-0 right-[68px]" />
                </div>
              </>
            ) : (
              <div className="flex justify-center p-3 w-[70px] h-[74px]">
                <div className="flex justify-center relative top-[10px] group">
                  <Link to="/Com" style={current_period > 0 ? null : { pointerEvents: "none" }}>
                    <FileImg stroke="#7e84a3" fill="#7e84a3" />
                  </Link>
                  <div className="bg-mainGreen h-15 p-3 absolute left-[-200px] bottom-[14px] rounded-full opacity-0 group-hover:left-[40px] group-hover:opacity-100 text-white">Communiquer</div>
                </div>
              </div>
            )}
          </div>
          <div className="bg-[#959DA6] h-[1px] w-10 absolute top-[50%]" />
        </div>
        <div className="w-16 h-40 absolute bottom-[0px] pt-[70px]">
          <div className="flex justify-center w-16">
            <div className="w-[15px] flex justify-center">
              <Link to={"/Help"} style={current_period > 0 ? null : { pointerEvents: "none" }}>
                <QuestionMark width="18" height="18" stroke="#7e84a3" />
              </Link>
            </div>
          </div>

          <div className="mt-[20px]">
            <Link to="/Profile">
              <div
                className={
                  (location.pathname === "/Profile" ? "border-[1.5px] border-mainGreen" : "") + " bg-[#57B8FF] w-10 h-10 absolute left-3 rounded-full flex justify-center items-center text-white"
                }
              >
                {user_info && user_info.user_info.email.slice(0, 2).toUpperCase()}
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavbarLeft;
